module.exports = __webpack_public_path__ + "img/farming_42.217aed0c.png";